import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SwiperOptions } from 'swiper/types/swiper-options';
import { AudioTour } from 'src/app/core/types/models/audio-tour';
import { SwiperDirective } from '../../directives/swiper.directive';

import { SsrHelperService } from 'src/app/core/services/ssr-helper.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { AudioPlayerService } from 'src/app/core/services/audio-player.service';

import { VoiceGuideListMobileComponent } from '../../../modules/countries/components/mobile/voice-guide-list-mobile/voice-guide-list-mobile.component';
import { VoiceGuideCardMobileComponent } from '../../../modules/countries/components/mobile/voice-guide-card-mobile/voice-guide-card-mobile.component';

@Component({
  selector: 'app-audio-tours',
  templateUrl: './audio-tours.component.html',
  styleUrls: ['./audio-tours.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgxSkeletonLoaderModule,
    SwiperDirective,
    VoiceGuideListMobileComponent,
    VoiceGuideCardMobileComponent,
  ],
  providers: [AudioPlayerService],
})
export class AudioToursComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) countryName: string;
  @Input({ required: true }) cityName: string;
  @Input() itineraryItem: any;
  @Input() isFirst: boolean = false;
  @Input() isFetching: boolean = false;

  public tours: AudioTour[] = [];
  public fetchingTours: number[] = new Array(9);

  swiperOptions: SwiperOptions = {
    init: true,
    speed: 650,
    spaceBetween: 24,
    slidesPerView: 'auto',
    breakpoints: {
      320: {
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 8,
      },
      624: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      },
    },
    navigation: {
      disabledClass: 'rpf-swiper-btn-disabled',
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  @ViewChild(SwiperDirective) swiper: SwiperDirective;

  constructor(
    private readonly ssrHelperService: SsrHelperService,
    private readonly audioPlayerService: AudioPlayerService,
    private readonly cdr: ChangeDetectorRef,
    protected breakpointService: BreakpointService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.itineraryItem?.currentValue) {
      this.tours = this.itineraryItem;
      this.swiper?.updateSwiper();
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy() {
    if (!this.ssrHelperService.userAgent) return;
    this.audioPlayerService.pause(true);
  }
}
